module.exports = __webpack_public_path__ + "img/tuwen.bf9e513c.png";